import React, { useState } from "react";
import { ApiService } from "../services";
import { useSnackbar } from "react-simple-snackbar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GButton from "../gComponents/gButton";
import { CustomerFilter } from "./customerFilterComponent";
import GText from "../gComponents/gText";
import { Cancel } from "@material-ui/icons";
import TooltipComponent from "../gComponents/gTooltip";
import Modal from "react-modal";
import LocalizationForm from "../forms/localizationForm";
import useSettings from "../useSettings";

export default function BulkNotifications() {
  const [openSnackbar] = useSnackbar();
  const settings = useSettings();
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [customerId, setCustomerId] = useState("");
  const [switchCustomersVal, setSwitchCustomersVal] = useState(false);
  const [selectedCustomers, setSelectedCutomers] = useState([]);
  const [localizationsArray, setLocalizationsArray] = useState([]);
  const [localizationVisible, setLocalizationVisible] = useState(false);
  const initialValues = {
    title: "",
    subtitle: "",
    customers: [],
    localizations: [],
  };

  const onSubmit = (values, { setFieldValue, resetForm }) => {
    let assignedCustomers = [];

    selectedCustomers.map((cus) => {
      assignedCustomers.push(cus.id);
    });

    values.customers = switchCustomersVal == true ? [] : assignedCustomers;
    values.localizations = localizationsArray;
    console.log(values);
    setIsBtnDisabled(true);
    ApiService({
      method: "POST",
      route: "promotion/push",
      body: values,
    }).then((response) => {
      console.log("r" + response.data.status_code);
      if (response.data.status_code === 1) {
        setFieldValue("title", "");
        setFieldValue("subtitle", "");
        resetForm(initialValues);
        setSelectedCutomers([]);
        setLocalizationsArray([]);
        setCustomerId("");
      }
      setIsBtnDisabled(false);
      openSnackbar(response.data.message);
      return;
    });
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Required"),
    subtitle: Yup.string().required("Required"),
  });

  return (
    <div className="mainInnerView">
      <h1>Bulk Notifications</h1>
      <div className="listPaper">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          <Form style={{ width: "90%" }}>
            <FormikControl
              control="input"
              type="text"
              label="Title"
              name="title"
              divstyle={{ width: "500px" }}
            />
            <FormikControl
              control="input"
              as="textarea"
              type="text"
              label="Subtitle"
              name="subtitle"
              rows="5"
              divstyle={{ width: "500px" }}
            />

            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "0 15px",
              }}
            >
              <label
                style={{
                  display: "inline-block",
                  fontSize: "0.98rem",
                  color: "#333",
                  width: "170px",
                  margin: 0,
                  fontWeight: 500,
                }}
              >
                Send to all Customers
              </label>
              <FormikControl
                control="toggle"
                isToggled={switchCustomersVal}
                name="is_customer"
                onToggle={() => {
                  setSwitchCustomersVal(!switchCustomersVal);
                }}
              />
            </div>
            {switchCustomersVal != true && (
              <div>
                <div
                  style={{
                    margin: "15px 15px 0",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <label
                    style={{
                      fontSize: "0.98rem",
                      color: "#333",
                      width: "170px",
                      margin: 0,
                      fontWeight: 500,
                    }}
                  >
                    Select Customers
                  </label>
                  <CustomerFilter
                    value={customerId}
                    handleCustomerChange={(value, data) => {
                      setCustomerId(value || "");
                      if (value) {
                        let selectedInd = selectedCustomers.findIndex(
                          (s) => s.id == value
                        );
                        if (selectedInd == -1) {
                          selectedCustomers.push({
                            id: value,
                            title: data.title,
                            email: data.email,
                            phone: data.phone,
                          });
                          setSelectedCutomers([...selectedCustomers]);
                        }
                      }
                    }}
                    style={{ width: "300px" }}
                  />
                </div>
                {selectedCustomers.length > 0 && (
                  <div
                    style={{
                      border: "1px solid #e2e2e2",
                      padding: "7px 5px",
                      marginTop: "15px",
                    }}
                  >
                    {selectedCustomers.map((c, i) => {
                      return (
                        <TooltipComponent
                          title={c.title}
                          position="top"
                          id={c.id}
                          subtitle={`${c.email} \n ${c.phone || ""}`}
                          theme={"white"}
                          tooltipStyle={{
                            textAlign: "left",
                            minWidth: "auto",
                            borderRadius: "4px",
                            left: "60%",
                          }}
                          divStyle={{ margin: 0 }}
                        >
                          <div
                            style={{
                              margin: "5px",
                              display: "inline-flex",
                              background: "#f4f5f9",
                              borderRadius: "4px",
                              padding: "2px 10px",
                              alignItems: "center",
                              position: "relative",
                            }}
                          >
                            <div>
                              <GText
                                semi
                                text={c.title}
                                style={{ margin: "2px 5px", fontSize: "14px" }}
                              />
                            </div>
                            <Cancel
                              onClick={() => {
                                selectedCustomers.splice(i, 1);
                                setSelectedCutomers([...selectedCustomers]);
                              }}
                              style={{ width: "18px", marginLeft: 10 }}
                            />
                          </div>
                        </TooltipComponent>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
            {settings?.locales && settings?.locales.length > 0 && (
              <div style={{ margin: "15px 15px 0" }}>
                <label>Localizations</label>

                {localizationsArray.length > 0 ? (
                  <GButton
                    variant="linkable"
                    onClick={() => setLocalizationVisible(true)}
                  >
                    {localizationsArray.length} Localizations added
                  </GButton>
                ) : (
                  <GButton
                    variant="linkable"
                    children="+ Add Localization"
                    onClick={() => setLocalizationVisible(true)}
                  />
                )}
              </div>
            )}
            <div style={{ display: "flex", margin: "25px 15px 20px 15px" }}>
              <GButton
                type="submit"
                disabled={isBtnDisabled}
                variant="condensed"
                children="Send Notification"
              />
              <GText
                semi
                text={
                  switchCustomersVal == true
                    ? "(All Customers)"
                    : `(${selectedCustomers.length} Customers)`
                }
                style={{ width: "auto", marginLeft: 15 }}
              />
            </div>
          </Form>
        </Formik>
      </div>

      <Modal
        isOpen={localizationVisible}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setLocalizationVisible(false)}
        style={{
          content: {
            width: "600px",
          },
        }}
        contentLabel="Localization Form Modal"
      >
        <LocalizationForm
          localizationVisible={localizationVisible}
          setLocalizationVisible={setLocalizationVisible}
          data={localizationsArray}
          onSubmit={(data) => {
            setLocalizationsArray([...data]);
          }}
          keyArray={[
            { title: "Title", value: "title" },
            { title: "Subtitle", value: "sub_title" },
          ]}
          variables={[]}
        />
      </Modal>
    </div>
  );
}
